var path = '/pages/contacts/directives/sections/messages/contact-messages.tpl.html';
var html = "<listview store=\"vm.store\"></listview>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/contacts/directives/sections/messages/contact-messages.tpl.html
// module id = 2222
// module chunks = 1